export default "__VITE_ASSET__pLHaeIk6__"